import { myAxios, axiosDownloadFile } from 'api/axios';

export const uploadFile = (file) => myAxios.post('/v1/import/uploadFile', file);

export const uploadFilesRequest = (files) => myAxios.post('/v1/import/uploadFiles', files);

export const downloadFileAxios = (id) => axiosDownloadFile.get(`/v1/import/downloadFile/${id}`);

export const removeFiles = (files) => myAxios.post('/v1/import/deleteFiles', files);
